import { useSelector } from "react-redux";
import IntermediaryAction from "@common/redux/actions/IntermediaryAction";
import CustomerClient from "@common/api/CustomerClient";
import { mapCustomerStatus } from "../helpers/labels";
import { getCustomerName } from "../helpers/name";

let modalResolver = null;

const useIntermediaryModal = () => {
  const data = useSelector((state) => IntermediaryAction.getStatePath(state));

  
  const openFacialMatchAlert = async (alert) => {
    const frsEventTypeId = alert.frsEventTypeId;
    
    let latestRiskScore = null;
    let latestInteractionDate = null;
    
    if (frsEventTypeId === 1) {
      const customer = await CustomerClient.Read(alert?.customerId);
      latestRiskScore = customer?.riskScore ?? null;
      latestInteractionDate = customer?.customerStats?.lastInteractionDate ?? null;
    }

    IntermediaryAction.dispatch({
      open: true,
      alertTime: alert.alertTime,
      capturedImage: alert.capturedImage,
      customerId: alert.customerId,
      estimatedAge: alert.estimatedAge,
      estimatedGender: alert.gender,
      frsEventReference: alert.frsEventReference,
      frsEventTypeId: alert.frsEventTypeId,
      customerName: getCustomerName(alert.customer),
      customerState: mapCustomerStatus(alert.customer),
      customerImage: alert.customer?.images[0]?.image,
      latestRiskScore,
      latestInteractionDate,
    });
    return new Promise((resolve) => modalResolver = resolve);
  };

  const confirmModal = () => {
    if (modalResolver) {
      modalResolver(true);
      modalResolver = null;
    }

    IntermediaryAction.reset();
  };

  const notConfirmedModal = () => {
    if (modalResolver) {
      modalResolver(false);
      modalResolver = null;
    }

    IntermediaryAction.reset();
  };

  const closeIntermediaryModal = () => IntermediaryAction.reset();

  return {
    ...data,
    openFacialMatchAlert,
    closeIntermediaryModal,
    confirmModal,
    notConfirmedModal
  };
};

export default useIntermediaryModal;
